import Session        from '@/shared/services/session';
import Records        from '@/shared/services/records';
import Flash          from '@/shared/services/flash';
import EventBus       from '@/shared/services/event_bus';
import AbilityService from '@/shared/services/ability_service';
import StanceService  from '@/shared/services/stance_service';
import LmoUrlService  from '@/shared/services/lmo_url_service';
import openModal      from '@/shared/helpers/open_modal';
import { I18n }           from '@/i18n';
import { hardReload } from '@/shared/helpers/window';
import { exportTemplateFile } from '@/shared/helpers/template_file';

export default new class PollTemplateService {
  canCreateTemplate(group) {
    return Session.isSignedIn() && !!group.id && (
      group.adminsInclude(Session.user()) ||
      (group.membersCanCreateTemplates && group.membersInclude(Session.user()))
    );
  }

  canEditTemplate(pollTemplate, group) {
    return group.adminsInclude(Session.user()) ||
      (group.membersCanCreateTemplates && pollTemplate.authorId === Session.user().id);
  }

  actions(pollTemplate, group) {
    const service = this;
    return {
      edit_default_template: {
        name: 'poll_common.edit_template',
        icon: 'mdi-pencil',
        menu: true,
        canPerform() { return !pollTemplate.id && group.adminsInclude(Session.user()); },
        to() {
          return `/poll_templates/new?template_key=${pollTemplate.key}&group_id=${group.id}&return_to=${Session.returnTo()}`;
        }
      },

      edit_template: {
        name: 'poll_common.edit_template',
        icon: 'mdi-pencil',
        menu: true,
        canPerform() { return pollTemplate.id && service.canEditTemplate(pollTemplate, group); },
        to() {
          return `/poll_templates/${pollTemplate.id}/edit?&return_to=${Session.returnTo()}`;
        }
      },

      fork_template: {
        name: 'templates.make_a_copy',
        icon: 'mdi-content-copy',
        menu: true,
        canPerform() { return pollTemplate.id && service.canEditTemplate(pollTemplate, group); },
        to() {
          return `/poll_templates/new?template_id=${pollTemplate.id}&group_id=${group.id}&return_to=${Session.returnTo()}`;
        }
      },

      export_json: {
        name: 'common.action.export_json',
        icon: 'mdi-download',
        menu: true,
        canPerform() { return !!(pollTemplate.id || pollTemplate.key); },
        perform() {
          exportTemplateFile('poll_template', pollTemplate, group.id);
        }
      },

      rearrange: {
        name: 'common.action.rearrange',
        icon: 'mdi-arrow-up-down',
        menu: true,
        canPerform() { return !pollTemplate.hiddenAt && group.adminsInclude(Session.user()); },
        perform() { return EventBus.$emit('sortPollTemplates'); }
      },

      hide_template: {
        icon: 'mdi-eye-off',
        name: 'common.action.hide',
        menu: true,
        canPerform() { return pollTemplate.id && !pollTemplate.hiddenAt && service.canEditTemplate(pollTemplate, group); },
        perform() {
          return Records.remote.post('poll_templates/hide', {group_id: group.id, id: pollTemplate.id});
        }
      },

      unhide_template: {
        icon: 'mdi-eye',
        name: 'common.action.unhide',
        menu: true,
        canPerform() { return pollTemplate.id && pollTemplate.hiddenAt && service.canEditTemplate(pollTemplate, group); },
        perform() {
          return Records.remote.post('poll_templates/unhide', {group_id: group.id, id: pollTemplate.id});
        }
      },

      destroy: {
        icon: 'mdi-delete',
        name: 'common.action.delete',
        menu: true,
        canPerform() { return pollTemplate.id && service.canEditTemplate(pollTemplate, group); },
        perform() {
          return openModal({
            component: 'ConfirmModal',
            props: {
              confirm: {
                submit() {
                  return pollTemplate.destroy().then(() => EventBus.$emit('closeModal'));
                },
                text: {
                  title: 'common.are_you_sure',
                  helptext: 'poll_common_form.confirm_delete',
                  submit: 'common.action.delete'
                }
              }
            }
          });
        }
      },

      hide: {
        icon: 'mdi-eye-off',
        name: 'common.action.hide',
        menu: true,
        canPerform() {
          return !pollTemplate.id && pollTemplate.key && !pollTemplate.hiddenAt && group.adminsInclude(Session.user());
        },
        perform() {
          return Records.remote.post('poll_templates/hide', {group_id: group.id, key: pollTemplate.key});
        }
      },

      unhide: {
        icon: 'mdi-eye',
        name: 'common.action.unhide',
        menu: true,
        canPerform() {
          return !pollTemplate.id && pollTemplate.key && pollTemplate.hiddenAt && group.adminsInclude(Session.user());
        },
        perform() {
          return Records.remote.post('poll_templates/unhide', {group_id: group.id, key: pollTemplate.key});
        }
      }
    };
  }
};
